import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const attempts = ['Los jugos verdes mágicos solo aumentan tu distensión abdominal por el exceso de fibra cruda.', 'El cardio intenso eleva tu cortisol, dándole la orden a tu cuerpo de acumular más agua y grasa en el abdomen.', 'Las dietas de "pechuga y lechuga" estresan tu microbiota, empeorando la respuesta inflamatoria.', 'Los suplementos caros no sirven de nada si tu intestino está demasiado irritado para absorberlos.'];
export const FailedAttempts = () => {
  return <section className="py-20 bg-cream-dark" data-id="element-14">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-17">
            Por qué lo que probaste antes no funcionó
          </h2>

          <div className="grid gap-6 md:grid-cols-2" data-id="element-18">
            {attempts.map((attempt, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-cream p-6 rounded-xl shadow-sm" data-id="element-19">
                <div className="flex-shrink-0 mt-1" data-id="element-20">
                  <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center" data-id="element-21">
                    <XIcon className="w-5 h-5 text-red-600" data-id="element-22" />
                  </div>
                </div>
                <p className="text-charcoal-light leading-relaxed font-medium" data-id="element-23">
                  {attempt}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
};